export const SET_PERSISTENCE = 'SET_PERSISTENCE'
export const RESET_STATE = 'RESET_STATE'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const SET_THEME_MODE = 'SET_THEME_MODE'
export const SET_GEOLOCATION = 'SET_GEOLOCATION'
export const SET_COORDS = 'SET_COORDS'
export const SET_VIN = 'SET_VIN'
export const SET_REPORT_URL = 'SET_REPORT_URL'
export const SET_REGISTERED_TRANSACTION = 'SET_REGISTERED_TRANSACTION'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_SEARCH_ID = 'SET_SEARCH_ID'